import { useSelector } from 'react-redux';

import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { IReportItem } from '../types';
import { selectEstimationByDealType } from '../../../selectors/estimation';
import { useScrollingBlockVisible } from '../../Scrolling/utils/useScrollingBlockVisible';
import { selectDealType } from '../../../selectors/page';

export function useReportItems(): IReportItem[] {
  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  const isPreciseFiltersVisible = useScrollingBlockVisible(EScrollingBlocks.PreciseFilters);
  const isHouseInfoVisible = useScrollingBlockVisible(EScrollingBlocks.AboutHome);
  const isRecommendationsVisible = useScrollingBlockVisible(EScrollingBlocks.Recommendations);
  const isEstimationChartVisible = useScrollingBlockVisible(EScrollingBlocks.EstimationChart);
  const isOffersHistoryVisible = useScrollingBlockVisible(EScrollingBlocks.OffersHistory);
  const isMarketTrendsVisible = useScrollingBlockVisible(EScrollingBlocks.MarketTrends);
  const isInfrastructureVisible = useScrollingBlockVisible(EScrollingBlocks.Infrastructure);
  const isManagementCompanyVisible = useScrollingBlockVisible(EScrollingBlocks.ManagementCompany);

  if (!estimation.data) {
    return [];
  }

  return [
    { name: 'Оценка', id: EScrollingBlocks.MarketPrice },
    isRecommendationsVisible && { name: 'Что дальше', id: EScrollingBlocks.Recommendations },
    isPreciseFiltersVisible && { name: 'Уточнить оценку', id: EScrollingBlocks.PreciseFilters },
    isEstimationChartVisible && { name: 'Динамика стоимости', id: EScrollingBlocks.EstimationChart },
    isMarketTrendsVisible && { name: 'Тренды рынка', id: EScrollingBlocks.MarketTrends },
    isOffersHistoryVisible && { name: 'История объявлений', id: EScrollingBlocks.OffersHistory },
    isManagementCompanyVisible && { name: 'Управляющая компания', id: EScrollingBlocks.ManagementCompany },
    isHouseInfoVisible && { name: 'О доме', id: EScrollingBlocks.AboutHome },
    isInfrastructureVisible && { name: 'Инфраструктура', id: EScrollingBlocks.Infrastructure },
  ].filter(Boolean) as IReportItem[];
}
